import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import { Box } from '@hausgold/designsystem';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var CalculationLayoutContainer = function CalculationLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(Box, _extends({
    textAlign: "center"
  }, props), children);
};
CalculationLayoutContainer.propTypes = {
  children: PropTypes.node
};
CalculationLayoutContainer.defaultProps = {
  children: null
};
export { CalculationLayoutContainer as default };